import React from "react";
import { Redirect } from "react-router-dom";
import * as paths from "routes/paths";

// MAX-3820: the legacy "/settings/location-customization" and "/settings/search-cities" routes were
// consolidated into "/settings/locations". Redirect any lingering bookmarks / deep links there.
export const SettingsLocationsRedirect: React.FC = () => (
	<Redirect to={paths.settingsLocations} />
);
